import { useEffect } from 'react';
import { useBreadcrumbs, BreadcrumbItem } from '../contexts/BreadcrumbContext';

export const usePageBreadcrumbs = (breadcrumbs: BreadcrumbItem[]) => {
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);

    // Очищаем breadcrumbs при размонтировании компонента
    return () => {
      setBreadcrumbs([]);
    };
  }, [breadcrumbs, setBreadcrumbs]);
};
